import axios from "axios"
export function getActiveScreens(token) {
    return axios.get(process.env.REACT_APP_API_URL + '/getActiveScreens', {
        headers: {
            'Authorization': `${token}`
        }});
}